import { collections, stickyAddress, statusMeta } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 border-b border-background-100/20 pb-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-article-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                黑料总站
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-8 text-background-100/75">
              黑料总站发布页，汇总黑料总站备用、黑料总站镜像、黑料总站新地址与黑料总站永久地址，
              为主站无法访问时提供稳定的备用入口。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-wechat-line", "ri-telegram-line", "ri-mail-line", "ri-bookmark-3-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/25 text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
                  >
                    <i className={icon} />
                  </span>
                ),
              )}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-label text-[11px] tracking-[0.28em] text-accent-400">
              通道信息
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-background-100/80">
              <li>当前通道：{statusMeta.activeChannel}</li>
              <li>在线线路：{statusMeta.totalChannels}</li>
              <li>最近更新：{statusMeta.updatedAt}</li>
              <li className="break-all">永久地址：{stickyAddress.host}</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-label text-[11px] tracking-[0.28em] text-accent-400">
              合集索引
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-background-100/80">
              {collections.slice(0, 4).map((item) => (
                <li key={item.id}>
                  <a href="#collections" className="transition-colors hover:text-background-50">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-label text-[11px] tracking-[0.28em] text-accent-400">
              快速到达
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-background-100/80">
              <li>
                <a href="#channels" className="transition-colors hover:text-background-50">
                  入口通道
                </a>
              </li>
              <li>
                <a href="#guide" className="transition-colors hover:text-background-50">
                  防走丢指南
                </a>
              </li>
              <li>
                <a href="#faq" className="transition-colors hover:text-background-50">
                  常见问题
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-8 text-xs text-background-100/65 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料总站发布页 · 本页仅作地址汇总与状态展示</p>
          <p className="sm:text-right">
            {statusMeta.issue} · 桌面与移动端均可正常浏览
          </p>
        </div>
      </div>
    </footer>
  );
}